import React from 'react';
import styles from './ClientTag.module.css';
import { useCursor } from '@/contexts/CursorContext';

interface ClientTagProps {
  label: string;
  selected?: boolean;
  onClick?: () => void;
}

export const ClientTag: React.FC<ClientTagProps> = ({
  label,
  selected = false,
  onClick,
}) => {
  const { setState } = useCursor();

  const onMouseEnter = () => {
    setState('link');
  };

  const onMouseLeave = () => {
    setState('default');
  };

  return (
    <button
      className={`${styles.clientTag} ${selected ? styles.selected : ''}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      type="button"
      aria-pressed={selected}
    >
      {label}
    </button>
  );
};
